/**
 * Notify Enum
 * @enum {NotifyEnum}
 */
export enum NotifyEnum {
	/**
	 * 翻譯中
	 */
	SessionStatusTranslating = 'channel_status_translating',
	/**
	 * 翻譯完成
	 */
	SessionStatusTranslateFinished = 'channel_status_translate_finished',
	/**
	 * TTS 轉換完成
	 */
	TTS_Finish = 'tts_finish',
	/**
	 * 主持人上線
	 */
	SessionStatusOnAir = 'channel_status_on_air',
	/**
	 * 主持人離線
	 */
	SessionStatusOffAir = 'channel_status_off_air',
	/**
	 * 會議結束
	 */
	SessionStatusClosed = 'channel_status_closed',
	/**
	 * 翻譯訊息
	 */
	TranslateMessage = 'translate_message',
	/**
	 * Session Summary Finished
	 */
	SummaryFinished = 'channel_summary_state_finished',
	/**
	 * 同步翻譯訊息
	 */
	SyncMessage = 'sync_message',
	/**
	 * 訊息最後一筆的時間
	 */
	LastMessageTime = 'last_message_created_time',
	/**
	 * 授權種類
	 */
	License = 'license',
	/**
	 * 標題改變
	 */
	TitleChange = 'title_change',
	/**
	 * 講者名稱更新用
	 */
	SpeakerUpdate = 'speaker_update',
	/**
	 * 原文訊息
	 */
	OriginalMessage = 'original_message',
	/**
	 * 原文編輯後的重譯結果；帶新原文與該語言新譯文，viewer 需同時更新兩者
	 */
	MessageUpdate = 'message_update',
	/**
	 * 原文編輯後的同步翻譯結果；帶該語言新的口譯文字
	 */
	MessageUpdateSync = 'message_update_sync',
	/**
	 * 是否要啟用TTS撥放按鈕
	 */
	ChannelCapabilityChange = 'channel_capability_change',
	/**
	 * 頻道設定重置完成；後端已套用所有設定，前端收到後重新抓取 channel meta
	 */
	ChannelReset = 'channel_reset',
	/**
	 * 頻道歷史紀錄被清除
	 */
	ChannelPurge = 'channel_purge',
	/**
	 * 頻道被替換為新頻道
	 */
	ChannelReplace = 'channel_replace',
	/**
	 * 子頻道換場；speaker 開啟新一場後後端廣播此通知，viewer 需整頁重載以重新領票進入當前場
	 */
	ChannelSessionRenewed = 'channel_session_renewed',
}
